export type RemovalErrorCode =
  | "removal_request_already_pending"
  | "project_not_empty"
  | "invalid_removal_action"
  | "cannot_delete_default_project"
  | "chief_role_required"
  | "not_request_initiator"
  | "removal_request_not_pending";

const REMOVAL_ERROR_CODES: readonly RemovalErrorCode[] = [
  "removal_request_already_pending",
  "project_not_empty",
  "invalid_removal_action",
  "cannot_delete_default_project",
  "chief_role_required",
  "not_request_initiator",
  "removal_request_not_pending",
];

function isRemovalErrorCode(value: unknown): value is RemovalErrorCode {
  return typeof value === "string" && (REMOVAL_ERROR_CODES as readonly string[]).includes(value);
}

function readData(error: unknown): Record<string, unknown> | null {
  if (typeof error !== "object" || error === null) return null;
  const data = (error as { data?: unknown }).data;
  if (typeof data !== "object" || data === null) return null;
  return data as Record<string, unknown>;
}

export function getRemovalErrorCode(error: unknown): RemovalErrorCode | null {
  const data = readData(error);
  if (!data) return null;
  return isRemovalErrorCode(data.error) ? data.error : null;
}

export function getRemovalBlockers(error: unknown): string[] {
  const data = readData(error);
  if (!data) return [];
  const blockers = data.blockers;
  return Array.isArray(blockers) ? blockers.filter((item): item is string => typeof item === "string") : [];
}
